<template>
  <div ref="rootRef" class="rich-html-case rich-html-case--lovableHome">
    <!-- Top Banner (poster1.html) -->
    <section class="poster-banner">
      <div class="poster">
        <div class="bg-dots"></div>
        <div class="bg-glow-1"></div>
        <div class="bg-glow-2"></div>
        <div class="geo-ring"></div>
        <div class="geo-diamond"></div>
        <svg
          class="bg-wave"
          viewBox="0 0 1920 380"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          preserveAspectRatio="none"
        >
          <path
            d="M0 380 L0 220 C180 180, 380 260, 580 200 C780 140, 980 240, 1180 190 C1380 140, 1580 220, 1780 170 C1840 155, 1880 165, 1920 160 L1920 380 Z"
            fill="rgba(9,202,176,0.06)"
          />
          <path
            d="M0 380 L0 260 C200 220, 420 290, 640 230 C860 170, 1080 260, 1300 210 C1520 160, 1720 230, 1920 190 L1920 380 Z"
            fill="rgba(9,202,176,0.045)"
          />
          <path
            d="M0 380 L0 300 C220 260, 460 320, 700 270 C940 220, 1180 300, 1420 250 C1660 200, 1820 260, 1920 240 L1920 380 Z"
            fill="rgba(9,202,176,0.03)"
          />
          <path
            d="M0 240 C200 200, 400 270, 600 220 C800 170, 1000 250, 1200 200 C1400 150, 1600 220, 1920 180"
            stroke="rgba(9,202,176,0.16)"
            stroke-width="1.5"
            fill="none"
          />
          <path
            d="M0 280 C240 240, 480 300, 720 250 C960 200, 1200 280, 1440 230 C1680 180, 1800 230, 1920 210"
            stroke="rgba(9,202,176,0.12)"
            stroke-width="1.2"
            fill="none"
          />
          <path
            d="M0 320 C260 290, 520 340, 780 300 C1040 260, 1300 330, 1560 280 C1700 255, 1820 290, 1920 270"
            stroke="rgba(9,202,176,0.09)"
            stroke-width="1"
            fill="none"
          />
        </svg>
        <div class="bottom-line"></div>

        <div class="brand-mark">
          <div class="brand-mark__logo">🐾</div>
          宠爱有家
        </div>

        <div class="poster__inner">
          <div class="poster__left">
            <div class="badge">
              <svg viewBox="0 0 24 24" fill="currentColor">
                <path
                  d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"
                />
              </svg>
              智能宠物生活管理平台
            </div>
            <h1 class="poster__title"><span>宠爱</span>有家</h1>
            <p class="poster__subtitle">全场景智能宠物生活管理平台</p>
            <div class="poster__divider"></div>

            <div class="poster__features">
              <div class="poster__feature">
                <div class="poster__feature-icon">
                  <svg
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  >
                    <rect x="2" y="3" width="20" height="14" rx="2" />
                    <line x1="8" y1="21" x2="16" y2="21" />
                    <line x1="12" y1="17" x2="12" y2="21" />
                  </svg>
                </div>
                <div>
                  <div class="poster__feature-name">多维设备智控中枢</div>
                  <div class="poster__feature-desc">
                    多品类硬件接入 · 远程投喂 · 固件升级
                  </div>
                </div>
              </div>
              <div class="poster__feature">
                <div class="poster__feature-icon">
                  <svg
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  >
                    <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
                    <circle cx="12" cy="7" r="4" />
                  </svg>
                </div>
                <div>
                  <div class="poster__feature-name">生物识别防丢系统</div>
                  <div class="poster__feature-desc">
                    面部/鼻纹识别 · 扫码送我回家
                  </div>
                </div>
              </div>
              <div class="poster__feature">
                <div class="poster__feature-icon">
                  <svg
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  >
                    <path d="M22 12h-4l-3 9L9 3l-3 9H2" />
                  </svg>
                </div>
                <div>
                  <div class="poster__feature-name">全生命周期健康管理</div>
                  <div class="poster__feature-desc">
                    电子档案 · 智能提醒 · 数据追踪
                  </div>
                </div>
              </div>
              <div class="poster__feature">
                <div class="poster__feature-icon">
                  <svg
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  >
                    <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
                  </svg>
                </div>
                <div>
                  <div class="poster__feature-name">高扩展性架构设计</div>
                  <div class="poster__feature-desc">
                    房间管理 · 多单位切换 · 消息中心
                  </div>
                </div>
              </div>
            </div>

            <div class="poster__stats">
              <div class="poster__stat">
                <div class="poster__stat-value">5<sup>+</sup></div>
                <div class="poster__stat-label">硬件品类</div>
              </div>
              <div class="poster__stat">
                <div class="poster__stat-value">±5<small>g</small></div>
                <div class="poster__stat-label">投喂精度</div>
              </div>
              <div class="poster__stat">
                <div class="poster__stat-value">24<small>h</small></div>
                <div class="poster__stat-label">全天监测</div>
              </div>
              <div class="poster__stat">
                <div class="poster__stat-value">99<sup>%</sup></div>
                <div class="poster__stat-label">识别准确率</div>
              </div>
            </div>
          </div>

          <div class="poster__right">
            <div class="phone-secondary">
              <div class="phone-wrap">
                <div class="phone-frame phone-frame--sec">
                  <div class="phone-island phone-island--sec"></div>
                  <div class="phone-screen phone-screen--sec">
                    <img
                      :src="bannerPhoneSecondary"
                      alt="宠爱有家"
                      @error="onImageError"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="phone-main">
              <div class="phone-wrap">
                <div class="phone-frame phone-frame--main">
                  <div class="phone-island phone-island--main"></div>
                  <div class="phone-screen phone-screen--main">
                    <img
                      :src="bannerPhoneMain"
                      alt="宠爱有家"
                      @error="onImageError"
                    />
                  </div>
                </div>
              </div>
              <div class="phone-glow"></div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Project Introduction -->
    <section class="project-intro">
      <div class="project-intro__inner">
        <img
          class="project-intro__title-img"
          :src="introduceText"
          alt="项目介绍"
        />
        <p class="project-intro__text fontRegular">{{ projectIntroduction }}</p>
      </div>
    </section>

    <div class="page-detail">
      <div class="container">
        <div class="s-divider"></div>
      </div>

      <!-- ===================================================
       用户分析
  =================================================== -->
      <section class="section">
        <div class="container">
          <div class="sec-label">
            <div class="sec-label__dot" style="background: #09cab0"></div>
            <span class="sec-label__cn">用户分析</span>
            <span class="sec-label__sep">/</span>
            <span class="sec-label__en">USER ANALYSIS</span>
          </div>
          <div class="user-analysis">
            <div class="ua__intro">
              <div class="ua__intro-title">
                这是该项目主要用户学习发展需求，定位市场中用户画像
              </div>
              <p class="ua__intro-desc">
                在对核心用户进行深度调研后，分析出主要用户群体的核心诉求差异，聚焦于其行为特征进行设计决策。
              </p>
            </div>
            <div class="ua__cards">
              <!-- ToC 普通宠主 -->
              <div class="ua-card ua-card--toc">
                <div class="ua-card__type">ToC · 普通宠主</div>
                <div class="ua-card__role">城市上班族养宠家庭</div>
                <div class="ua-card__desc">
                  工作繁忙，无法全天照料宠物，渴望借助科技手段实现"不在家也能好好爱宠物"
                </div>
                <div class="ua-card__pain">
                  <div class="ua-card__pain-item">
                    喂食时间不规律，宠物健康堪忧
                  </div>
                  <div class="ua-card__pain-item">宠物走失无法快速找回</div>
                  <div class="ua-card__pain-item">缺乏科学健康数据指导</div>
                </div>
                <div class="ua-card__icon">🐱</div>
              </div>
              <!-- ToB 品牌/渠道 -->
              <div class="ua-card ua-card--tob">
                <div class="ua-card__type">ToB · 产品运营者</div>
                <div class="ua-card__role">宠物品牌 / 渠道运营商</div>
                <div class="ua-card__desc">
                  希望通过智能硬件 + APP
                  生态构建用户粘性，形成"设备+服务+内容"的商业闭环
                </div>
                <div class="ua-card__pain">
                  <div class="ua-card__pain-item">设备激活率低，复购转化难</div>
                  <div class="ua-card__pain-item">缺乏有效的用户行为数据</div>
                  <div class="ua-card__pain-item">多品类设备管理混乱</div>
                </div>
                <div class="ua-card__icon">💼</div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <div class="container">
        <div class="s-divider"></div>
      </div>

      <!-- ===================================================
       行业分析
  =================================================== -->
      <section class="section swot">
        <div class="container">
          <div class="sec-label">
            <div class="sec-label__dot" style="background: #ec4899"></div>
            <span class="sec-label__cn">行业分析</span>
            <span class="sec-label__sep">/</span>
            <span class="sec-label__en">INDUSTRY ANALYSIS</span>
          </div>
          <div class="swot__bg-text">ANALYSIS</div>
          <div class="swot__grid">
            <div class="swot-card swot-card--s">
              <div class="swot-card__letter">01</div>
              <div class="swot-card__tag">IoT 融合</div>
              <div class="swot-card__title">智能硬件与宠物经济深度融合</div>
              <ul class="swot-card__list">
                <li>
                  随着 IoT
                  技术成熟与成本下降，智能宠物设备正从"玩具"升级为"刚需"
                </li>
                <li>消费者对宠物照护的科技依赖度持续提升</li>
                <li>90/00 后单身宠主群体倾向于数据化管理宠物生活</li>
                <li>推动智能喂食器、智能猫厕所等硬件的快速普及</li>
              </ul>
            </div>
            <div class="swot-card swot-card--w">
              <div class="swot-card__letter">02</div>
              <div class="swot-card__tag">生物识别</div>
              <div class="swot-card__title">宠物防丢与生物识别迎来政策红利</div>
              <ul class="swot-card__list">
                <li>多个城市已将宠物芯片登记纳入城市管理规范</li>
                <li>宠物身份数字化进程加速</li>
                <li>面部识别与鼻纹识别技术在海外已得到验证</li>
                <li>国内市场空白明显，先发优势平台将快速建立技术壁垒</li>
              </ul>
            </div>
            <div class="swot-card swot-card--o">
              <div class="swot-card__letter">03</div>
              <div class="swot-card__tag">开放生态</div>
              <div class="swot-card__title">
                开放平台生态是智能宠物APP的终局
              </div>
              <ul class="swot-card__list">
                <li>仅靠单一设备无法构建长期护城河</li>
                <li>以APP为中枢、开放硬件接入标准</li>
                <li>联动宠物医疗/美容/保险服务商</li>
                <li>形成"平台 + 生态"模式，才是可持续路径</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      <div class="container">
        <div class="s-divider"></div>
      </div>

      <!-- ===================================================
       产品目标
  =================================================== -->
      <section class="section">
        <div class="container">
          <div class="sec-label">
            <div class="sec-label__dot" style="background: #34d399"></div>
            <span class="sec-label__cn">产品目标</span>
            <span class="sec-label__sep">/</span>
            <span class="sec-label__en">PRODUCT GOALS</span>
          </div>
          <p
            style="
              font-size: 13px;
              color: var(--text-muted);
              margin-bottom: 28px;
              line-height: 1.7;
            "
          >
            根据用户痛点可以找到的产品的机会点方向
          </p>
          <div class="product-goals">
            <div class="pg-row">
              <div class="pg-row__left">
                <div class="pg-row__title">多维设备智控中枢</div>
                <p class="pg-row__desc">
                  支持喂食器、背带等多品类硬件接入，提供远程投喂、状态诊断与固件升级服务，实现全屋宠物设备的统一管理。
                </p>
              </div>
              <div class="pg-row__arrow">
                <svg
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                >
                  <line x1="5" y1="12" x2="19" y2="12" />
                  <polyline points="12 5 19 12 12 19" />
                </svg>
              </div>
              <div class="pg-row__tags">
                <span class="pg-tag pg-tag--cyan">多粮食管理</span>
                <span class="pg-tag pg-tag--cyan">便捷操作视图</span>
                <span class="pg-tag pg-tag--cyan">门店运营数据</span>
                <span class="pg-tag pg-tag--teal">门店健康管理</span>
                <span class="pg-tag pg-tag--teal">多维度分析</span>
              </div>
            </div>
            <div class="pg-row">
              <div class="pg-row__left">
                <div class="pg-row__title">生物识别防丢系统</div>
                <p class="pg-row__desc">
                  创新性引入宠物面部及鼻纹识别技术，建立独一无二的生物档案，配合"扫码送我回家"功能，在宠物走失时快速联系宠主。
                </p>
              </div>
              <div class="pg-row__arrow">
                <svg
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                >
                  <line x1="5" y1="12" x2="19" y2="12" />
                  <polyline points="12 5 19 12 12 19" />
                </svg>
              </div>
              <div class="pg-row__tags">
                <span class="pg-tag pg-tag--blue">客户管理</span>
                <span class="pg-tag pg-tag--blue">客户分析</span>
                <span class="pg-tag pg-tag--blue">客户触达</span>
              </div>
            </div>
            <div class="pg-row">
              <div class="pg-row__left">
                <div class="pg-row__title">全生命周期健康管理</div>
                <p class="pg-row__desc">
                  搭建精细化的宠物电子档案，涵盖品种、健康、疫苗及运动数据，提供智能提醒服务，辅助宠主科学喂养。
                </p>
              </div>
              <div class="pg-row__arrow">
                <svg
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                >
                  <line x1="5" y1="12" x2="19" y2="12" />
                  <polyline points="12 5 19 12 12 19" />
                </svg>
              </div>
              <div class="pg-row__tags">
                <span class="pg-tag pg-tag--purple">健康追踪</span>
                <span class="pg-tag pg-tag--purple">拓知识库</span>
                <span class="pg-tag pg-tag--purple">决策信援</span>
                <span class="pg-tag pg-tag--purple">提效转化</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      <div class="container">
        <div class="s-divider"></div>
      </div>

      <!-- ===================================================
       核心功能
  =================================================== -->
      <section class="section">
        <div class="container">
          <div class="sec-label">
            <div class="sec-label__dot" style="background: #f59e0b"></div>
            <span class="sec-label__cn">核心功能</span>
            <span class="sec-label__sep">/</span>
            <span class="sec-label__en">CORE FEATURES</span>
          </div>
          <div class="features__grid">
            <div class="feat-card">
              <div class="feat-card__num">01</div>
              <div class="feat-card__body">
                <div class="feat-card__title">智能喂食控制</div>
                <p class="feat-card__desc">
                  支持远程手动投喂与多组定时喂食计划，精确控制每餐份量（g/cup/oz
                  三单位切换），饮食记录自动归档。
                </p>
                <div class="feat-card__tags">
                  <span
                    class="f-tag"
                    style="
                      background: var(--cyan-light);
                      color: var(--cyan-dark);
                    "
                    >远程投喂</span
                  >
                  <span
                    class="f-tag"
                    style="
                      background: var(--cyan-light);
                      color: var(--cyan-dark);
                    "
                    >定时计划</span
                  >
                  <span
                    class="f-tag"
                    style="
                      background: var(--cyan-light);
                      color: var(--cyan-dark);
                    "
                    >份量精准</span
                  >
                  <span
                    class="f-tag"
                    style="
                      background: var(--cyan-light);
                      color: var(--cyan-dark);
                    "
                    >干粮预估</span
                  >
                </div>
              </div>
            </div>
            <div class="feat-card">
              <div class="feat-card__num">02</div>
              <div class="feat-card__body">
                <div class="feat-card__title">生物识别与防丢</div>
                <p class="feat-card__desc">
                  独创宠物面部 +
                  鼻纹双重生物识别技术，建立专属身份档案；扫码快速联系宠主，走失找回率大幅提升。
                </p>
                <div class="feat-card__tags">
                  <span
                    class="f-tag"
                    style="background: #eef2ff; color: #4f46e5"
                    >面部识别</span
                  >
                  <span
                    class="f-tag"
                    style="background: #eef2ff; color: #4f46e5"
                    >鼻纹识别</span
                  >
                  <span
                    class="f-tag"
                    style="background: #eef2ff; color: #4f46e5"
                    >扫码找回</span
                  >
                </div>
              </div>
            </div>
            <div class="feat-card">
              <div class="feat-card__num">03</div>
              <div class="feat-card__body">
                <div class="feat-card__title">健康档案管理</div>
                <p class="feat-card__desc">
                  建立宠物电子健康档案，记录疫苗、驱虫、体检等关键节点，智能到期提醒，科学守护宠物全生命周期健康。
                </p>
                <div class="feat-card__tags">
                  <span
                    class="f-tag"
                    style="background: #f3e8ff; color: #7c3aed"
                    >电子档案</span
                  >
                  <span
                    class="f-tag"
                    style="background: #f3e8ff; color: #7c3aed"
                    >疫苗提醒</span
                  >
                  <span
                    class="f-tag"
                    style="background: #f3e8ff; color: #7c3aed"
                    >驱虫追踪</span
                  >
                </div>
              </div>
            </div>
            <div class="feat-card">
              <div class="feat-card__num">04</div>
              <div class="feat-card__body">
                <div class="feat-card__title">高扩展性架构</div>
                <p class="feat-card__desc">
                  支持自定义房间管理、多设备分组、OTA
                  固件在线升级，完善的消息通知中心与权限管理，具备极强的扩展性。
                </p>
                <div class="feat-card__tags">
                  <span
                    class="f-tag"
                    style="background: #fff3e8; color: #d97706"
                    >房间管理</span
                  >
                  <span
                    class="f-tag"
                    style="background: #fff3e8; color: #d97706"
                    >OTA 升级</span
                  >
                  <span
                    class="f-tag"
                    style="background: #fff3e8; color: #d97706"
                    >消息中心</span
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <!-- ===================================================
       界面展示 — 5台手机横排
  =================================================== -->
      <section class="showcase ui-showcase">
        <div class="container">
          <div class="sec-label" style="margin-bottom: 0">
            <div class="sec-label__dot" style="background: #09cab0"></div>
            <span class="sec-label__cn">界面展示</span>
            <span class="sec-label__sep">/</span>
            <span class="sec-label__en">UI SHOWCASE</span>
          </div>
          <div class="showcase__header">
            <div class="showcase__title-block">
              <div class="showcase__main-title">核心功能界面</div>
              <div class="showcase__subtitle">
                从登录到设备管理、宠物档案的完整用户旅程
              </div>
            </div>
          </div>
          <div class="showcase__phones">
            <div class="phone-mockup phone-mockup--md phone-mockup--left-1">
              <div class="phone-frame">
                <img
                  alt="爱宠列表"
                  :src="getImage('pet-list.jpg')"
                  @error="onImageError"
                />
              </div>
              <div class="phone-label">爱宠列表</div>
            </div>
            <div class="phone-mockup phone-mockup--md phone-mockup--left-2">
              <div class="phone-frame">
                <img
                  alt="帮助指南"
                  :src="getImage('help-guide.jpg')"
                  @error="onImageError"
                />
              </div>
              <div class="phone-label">帮助指南</div>
            </div>
            <div class="phone-mockup phone-mockup--lg phone-mockup--center">
              <div class="phone-frame phone-frame--lg">
                <img
                  alt="宠物背带详情"
                  :src="getImage('harness-detail-page2.jpg')"
                  @error="onImageError"
                />
              </div>
              <div class="phone-label">宠物背带详情</div>
            </div>
            <div class="phone-mockup phone-mockup--md phone-mockup--right-1">
              <div class="phone-frame">
                <img
                  alt="上传鼻纹"
                  :src="getImage('upload-nose-print.jpg')"
                  @error="onImageError"
                />
              </div>
              <div class="phone-label">上传鼻纹</div>
            </div>
            <div class="phone-mockup phone-mockup--md phone-mockup--right-2">
              <div class="phone-frame">
                <img
                  alt="个人中心"
                  :src="getImage('profile-logged-in.jpg')"
                  @error="onImageError"
                />
              </div>
              <div class="phone-label">个人中心</div>
            </div>
          </div>
        </div>
      </section>

      <!-- ===================================================
       部分页面展示
  =================================================== -->
      <section class="screens-section">
        <div class="container">
          <div class="sec-label">
            <div class="sec-label__dot" style="background: #09cab0"></div>
            <span class="sec-label__cn">部分页面展示</span>
            <span class="sec-label__sep">/</span>
            <span class="sec-label__en">PAGE GALLERY</span>
          </div>
          <div class="screens__grid">
            <div class="screen-item">
              <div class="phone-frame phone-frame--screen">
                <img
                  alt="设备列表"
                  :src="getImage('device-list.jpg')"
                  @error="onImageError"
                />
              </div>
              <div class="screen-item__label">设备列表</div>
            </div>
            <div class="screen-item">
              <div class="phone-frame phone-frame--screen">
                <img
                  alt="扫码查看宠物背带"
                  :src="getImage('scan-harness.jpg')"
                  @error="onImageError"
                />
              </div>
              <div class="screen-item__label">扫码查看宠物背带</div>
            </div>
            <div class="screen-item">
              <div class="phone-frame phone-frame--screen">
                <img
                  alt="选择登录方式"
                  :src="getImage('login-select.jpg')"
                  @error="onImageError"
                />
              </div>
              <div class="screen-item__label">选择登录方式</div>
            </div>
            <div class="screen-item">
              <div class="phone-frame phone-frame--screen">
                <img
                  alt="提醒"
                  :src="getImage('reminder.jpg')"
                  @error="onImageError"
                />
              </div>
              <div class="screen-item__label">提醒</div>
            </div>
            <div class="screen-item">
              <div class="phone-frame phone-frame--screen">
                <img
                  alt="添加宠物"
                  :src="getImage('add-pet-step2.jpg')"
                  @error="onImageError"
                />
              </div>
              <div class="screen-item__label">添加宠物</div>
            </div>
          </div>
        </div>
      </section>

      <!-- ===================================================
       技术参数
  =================================================== -->
      <section class="section specs-section">
        <div class="container">
          <div class="sec-label">
            <div class="sec-label__dot" style="background: #94a3b8"></div>
            <span class="sec-label__cn">技术参数</span>
            <span class="sec-label__sep">/</span>
            <span class="sec-label__en">TECH SPECS</span>
          </div>
          <div class="specs-bar">
            <div class="spec-item">
              <div class="spec-item__label">操作系统</div>
              <div class="spec-item__value">
                iOS / Android / <em>HarmonyOS</em>
              </div>
            </div>
            <div class="spec-item">
              <div class="spec-item__label">通信协议</div>
              <div class="spec-item__value">BLE + <em>Wi-Fi 2.4GHz</em></div>
            </div>
            <div class="spec-item">
              <div class="spec-item__label">AI 引擎</div>
              <div class="spec-item__value">面部+<em>鼻纹</em>识别算法</div>
            </div>
            <div class="spec-item">
              <div class="spec-item__label">喂食精度</div>
              <div class="spec-item__value">单份 <em>±5g</em> 精准出粮</div>
            </div>
            <div class="spec-item">
              <div class="spec-item__label">多单位支持</div>
              <div class="spec-item__value"><em>g</em> / cup / oz</div>
            </div>
            <div class="spec-item">
              <div class="spec-item__label">网络架构</div>
              <div class="spec-item__value">云端同步+<em>本地缓存</em></div>
            </div>
          </div>
        </div>
      </section>

      <!-- ===================================================
       设计规范
  =================================================== -->
      <section
        class="section"
        style="background: var(--bg-light); padding-top: 50px"
      >
        <div class="container">
          <div class="sec-label">
            <div class="sec-label__dot" style="background: #09cab0"></div>
            <span class="sec-label__cn">设计规范</span>
            <span class="sec-label__sep">/</span>
            <span class="sec-label__en">DESIGN SYSTEM</span>
          </div>
          <p
            style="
              font-size: 13px;
              color: var(--text-muted);
              max-width: 560px;
              line-height: 1.7;
              margin-bottom: 32px;
            "
          >
            基于 74 个 UI
            界面提炼的设计语言体系，覆盖颜色、字体、组件、间距与图标五大维度，确保全链路视觉一致性。
          </p>
          <div class="design-system__grid">
            <div class="ds-main">
              <!-- 颜色系统 -->
              <div class="ds-card ds-card--full">
                <div class="ds-card__title">颜色系统 / Color</div>
                <div class="ds-colors">
                  <div class="ds-color-row">
                    <div class="ds-color-swatch" style="background: #09cab0">
                      <span class="ds-color-swatch__name">Primary</span>
                      <span class="ds-color-swatch__hex">#09CAB0</span>
                    </div>
                    <div class="ds-color-swatch" style="background: #07a890">
                      <span class="ds-color-swatch__name">Dark</span>
                      <span class="ds-color-swatch__hex">#07A890</span>
                    </div>
                    <div
                      class="ds-color-swatch ds-color-swatch--dark"
                      style="background: #e6faf7"
                    >
                      <span class="ds-color-swatch__name">Light</span>
                      <span class="ds-color-swatch__hex">#E6FAF7</span>
                    </div>
                  </div>
                  <div class="ds-color-row">
                    <div
                      class="ds-color-swatch ds-color-swatch--dark"
                      style="
                        background: #ffffff;
                        border: 1px solid var(--border);
                      "
                    >
                      <span class="ds-color-swatch__name">Background</span>
                      <span class="ds-color-swatch__hex">#FFFFFF</span>
                    </div>
                    <div
                      class="ds-color-swatch ds-color-swatch--dark"
                      style="
                        background: #f5fdfb;
                        border: 1px solid var(--border);
                      "
                    >
                      <span class="ds-color-swatch__name">Surface</span>
                      <span class="ds-color-swatch__hex">#F5FDFB</span>
                    </div>
                    <div class="ds-color-swatch" style="background: #1c1c1e">
                      <span class="ds-color-swatch__name">Text</span>
                      <span class="ds-color-swatch__hex">#1C1C1E</span>
                    </div>
                  </div>
                </div>
              </div>
              <!-- 字体系统 -->
              <div class="ds-card">
                <div class="ds-card__title">字体系统 / Typography</div>
                <div class="ds-type">
                  <div class="ds-type__item">
                    <span class="ds-type__label">H1 / 20px</span>
                    <span class="ds-type__sample ds-type__sample--h1"
                      >页面大标题</span
                    >
                  </div>
                  <div class="ds-type__item">
                    <span class="ds-type__label">H2 / 16px</span>
                    <span class="ds-type__sample ds-type__sample--h2"
                      >模块标题</span
                    >
                  </div>
                  <div class="ds-type__item">
                    <span class="ds-type__label">H3 / 14px</span>
                    <span class="ds-type__sample ds-type__sample--h3"
                      >卡片标题</span
                    >
                  </div>
                  <div class="ds-type__item">
                    <span class="ds-type__label">Body / 13px</span>
                    <span class="ds-type__sample ds-type__sample--body"
                      >正文内容与描述说明</span
                    >
                  </div>
                  <div class="ds-type__item">
                    <span class="ds-type__label">Caption / 11px</span>
                    <span class="ds-type__sample ds-type__sample--caption"
                      >辅助标签与提示</span
                    >
                  </div>
                </div>
              </div>
              <!-- 组件规范 -->
              <div class="ds-card">
                <div class="ds-card__title">组件规范 / Components</div>
                <div class="ds-components">
                  <button class="ds-btn ds-btn--primary">主要按钮</button>
                  <button class="ds-btn ds-btn--secondary">次要按钮</button>
                  <span class="ds-tag">标签</span>
                  <input class="ds-input" value="输入框" readonly />
                  <div class="ds-card-preview">
                    <div class="ds-card-preview__bar"></div>
                    卡片
                  </div>
                </div>
              </div>
              <!-- 间距系统 -->
              <div class="ds-card">
                <div class="ds-card__title">间距系统 / Spacing</div>
                <div class="ds-spacing">
                  <div class="ds-space__row">
                    <span class="ds-space__label">4px</span>
                    <div class="ds-space__bar" style="width: 16px"></div>
                    <span class="ds-space__value">图标间距</span>
                  </div>
                  <div class="ds-space__row">
                    <span class="ds-space__label">8px</span>
                    <div class="ds-space__bar" style="width: 32px"></div>
                    <span class="ds-space__value">元素内边距</span>
                  </div>
                  <div class="ds-space__row">
                    <span class="ds-space__label">16px</span>
                    <div class="ds-space__bar" style="width: 64px"></div>
                    <span class="ds-space__value">卡片间距</span>
                  </div>
                  <div class="ds-space__row">
                    <span class="ds-space__label">24px</span>
                    <div class="ds-space__bar" style="width: 96px"></div>
                    <span class="ds-space__value">模块间距</span>
                  </div>
                  <div class="ds-space__row">
                    <span class="ds-space__label">32px</span>
                    <div class="ds-space__bar" style="width: 128px"></div>
                    <span class="ds-space__value">区块间距</span>
                  </div>
                </div>
              </div>
              <!-- 图标系统 -->
              <div class="ds-card">
                <div class="ds-card__title">图标系统 / Icons</div>
                <div class="ds-icons">
                  <div class="ds-icon">
                    <div class="ds-icon__box">
                      <svg
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="2"
                      >
                        <path
                          d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"
                        />
                        <polyline points="9 22 9 12 15 12 15 22" />
                      </svg>
                    </div>
                    <span class="ds-icon__label">首页</span>
                  </div>
                  <div class="ds-icon">
                    <div class="ds-icon__box">
                      <svg
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="2"
                      >
                        <rect x="3" y="3" width="18" height="18" rx="3" />
                        <path d="M9 9h6M9 12h6M9 15h4" />
                      </svg>
                    </div>
                    <span class="ds-icon__label">档案</span>
                  </div>
                  <div class="ds-icon">
                    <div class="ds-icon__box">
                      <svg
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="2"
                      >
                        <path
                          d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7A8.38 8.38 0 0 1 4 11.5a8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z"
                        />
                      </svg>
                    </div>
                    <span class="ds-icon__label">消息</span>
                  </div>
                  <div class="ds-icon">
                    <div class="ds-icon__box">
                      <svg
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="2"
                      >
                        <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
                        <circle cx="12" cy="7" r="4" />
                      </svg>
                    </div>
                    <span class="ds-icon__label">我的</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>

    <!-- Page Summary -->
    <section class="page-summary">
      <div class="page-summary__inner">
        <p class="page-summary__text fontRegular">{{ detailIntroduction }}</p>
        <div class="page-summary__preview">
          <img
            v-for="(img, index) in previewImages"
            :key="'preview-' + index"
            :src="img"
            alt=""
          />
        </div>
        <div class="page-summary__back fontRegular" @click="goBack">返回</div>
      </div>
    </section>

    <!-- Related Cases -->
    <section class="related-cases">
      <div class="related-cases__inner">
        <div class="related-cases__title">
          <img :src="caseListText" alt="相关案例" />
        </div>
        <div class="related-cases__grid">
          <list-card
            v-for="(item, index) in relatedCaseList"
            :key="'related-case-' + index"
            class="noPadding"
            :src="item.image"
            :routeQuery="item.routeQuery"
            :keyIndex="index"
            :showDownName="false"
            :isRichHtml="true"
            :showFreeTrialTag="item.showFreeTrialTag"
            :backgroundColor="item.backgroundColor"
          />
        </div>
      </div>
    </section>
  </div>
</template>

<script setup>
import { onMounted, ref } from "vue";
import { useRouter } from "vue-router";
import ListCard from "@/components/list-card/index.vue";
import { initRichHtmlReveal } from "../utils/useRichHtmlReveal";
import imageMap from "./images";

const getImage = (name) => imageMap[name] || "";

const bannerPhoneMain = getImage("device-list.jpg");
const bannerPhoneSecondary = getImage("harness-detail-page2.jpg");

const onImageError = (event) => {
  const target = event.target;
  if (target) {
    target.style.display = "none";
  }
};

const introduceText = require("@/assets/images/introduce-text.png");
const caseListText = require("@/assets/images/case-list-text.png");

const projectIntroduction =
  "聚焦「养宠焦虑」核心痛点，以智能硬件管控为切入，融合生物识别、健康管理、社区互动等多维场景，打造城市宠物家庭的一站式智能生活解决方案。宠爱有家覆盖 iOS、Android 与 HarmonyOS，连接智能喂食器与宠物档案，让养宠更省心、更科学。";

const detailIntroduction =
  "云效科技崇尚创新，专注研发，拥有一支国内领先的技术团队，并凭借专业知识强、业务技术精、服务质量高、精神面貌佳等特点得到用户的一致赞誉。在软件开发的专业领域，云效科技与行业内诸多知名企业保持有长期稳定的合作关系。";

const previewImages = [
  require("@/assets/images/list-case/attract-investment/image-1.png"),
];

const relatedCaseList = [
  {
    image: require("@/assets/images/project-list-card/project-39.png"),
    backgroundColor: "#1C69C7",
    routeQuery: { name: "intelligentPetFeeder", isRichHtml: true },
  },
  {
    image: require("@/assets/images/project-list-card/project-36.png"),
    backgroundColor: "#0FBFAE",
    routeQuery: {
      name: "intelligentElectricAdjustmentSystem",
      isRichHtml: true,
    },
  },
  {
    image: require("@/assets/images/project-list-card/project-35.png"),
    backgroundColor: "#4459FE",
    routeQuery: {
      name: "channelAdvertisingFundManagementPlatform",
      isRichHtml: true,
    },
  },
];

const router = useRouter();
const rootRef = ref(null);

const goBack = () => {
  router.go(-1);
};

onMounted(() => {
  initRichHtmlReveal(rootRef.value);
});
</script>

<style lang="scss" src="./case.scss"></style>
<style lang="scss" src="./banner.scss"></style>
<style lang="scss" src="./layout.scss"></style>
